import React, { useContext } from 'react'
import { Flex, Box, Button, Text } from 'rebass/styled-components'
import styled, { ThemeContext } from 'styled-components'
import { Input, Textarea, Label } from '@rebass/forms/styled-components'
import { Checkbox } from '@rebass/forms'
// Styled components checkbox doesn't work so utilising ThemeContext to style standard rebass component.
import { useForm } from 'react-hook-form';

const ContactForm = styled(Box)`
    input:not([type='hidden']),
    textarea {
        background-color: ${(props) => props.theme.colors.white};
        border-color: ${(props) => props.theme.colors.aquaMedium};
        border-radius: 0;
        border-style: solid;
        border-width: 1px;
        font-family: ${(props) => props.theme.fonts.body};
        margin-bottom: ${(props) => props.theme.space.md};
        outline: none;

        transition-duration: 300ms;
        transition-timing-function: ease-out;
        transition-property: border-color;

        will-change: border-color;

        :focus {
            border-color: ${(props) => props.theme.colors.aquaDark};
        }
        &.error {
            border-color: ${(props) => props.theme.colors.errorLight};
            border-width: 2px;
        }
    }
    .error {
        color: ${(props) => props.theme.colors.errorDark};
    }
`

const GenericForm = ({ sendMail }) => {
    const url = typeof window !== 'undefined' ? window.location.href : 'Referring URL not available'
    const { register, handleSubmit, formState: { errors }} = useForm();
    const onSubmit = (data) => sendMail(data, 'contact_form');
    const theme = useContext(ThemeContext);

    return (
        <ContactForm
            // onSubmit={(e) => sendMail(e, 'contact_form')}
            as="form"
            autocomplete="on"
            name="contactFormRef" // This is for ScrollTo to work.
            onSubmit={handleSubmit(onSubmit)}
        >
            <Input type="hidden" name="subject" value="New Contact Form Submission" {...register('subject')} />
            <Input type="hidden" name="referrer" value={url} {...register('referrer')} />

            <Text
                as="label"
                htmlFor="form-name"
                hidden
            >
                Name
            </Text>
            <Input
                autoComplete="name"
                enterKeyHint="next"
                id="form-name"
                type="text"
                name="from_name"
                placeholder="Name" {...register('from_name', { required: true })}
            />
            {errors.from_name && <span className="errorMessage">Please enter your name.</span>}

            <Text
                as="label"
                htmlFor="form-email"
                hidden
            >
                Email
            </Text>
            <Input
                autoComplete="email"
                enterKeyHint="next"
                id="form-email"
                // className="error"
                placeholder="Email"
                type="email"
                name="reply_to" {...register('reply_to', { required: true })}
            />
            {errors.reply_to && <span className="errorMessage">Please enter a valid email.</span>}

            <Text
                as="label"
                htmlFor="form-tel"
                hidden
            >
                Contact number
            </Text>
            <Input autoComplete="tel" enterKeyHint="next" id="form-tel" type="tel" name="phone" placeholder="Phone" {...register('phone', { required: true })} />
            {errors.reply_to && <span className="errorMessage">Please provide a contact number.</span>}

            <Text
                as="label"
                htmlFor="form-comments"
                hidden
            >
                Comments
            </Text>
            <Textarea
                enterKeyHint="next"
                id="form-comments"
                name="message"
                placeholder="Comments"
                type="textarea" {...register('message', { required: true })}
                sx={{
                    overflow: 'auto',
                    minHeight: '115px',
                    resize: 'vertical',
                }}
            />
            {errors.message && <span className="errorMessage">Please write a brief message so we can respond as swiftly as possible.</span>}
            <Flex
                alignItems="center"
                justifyContent="space-between"
            >
                <Button
                    aria-pressed="false"
                    display={['block', 'block', 'block', 'block', 'inline-block', 'inline-block', 'inline-block']}
                    enterKeyHint="done"
                    // mt="md"
                    type="submit"
                    variant="primary"
                >Submit</Button>
                <Box>
                    <Label>
                        <Flex
                            alignItems="center">
                            <Text
                                mx="xs"
                            >Add me to the Newsletter</Text>
                        </Flex>
                        <Flex>
                            <Checkbox
                                id="newsletter_consent"
                                name="newsletter_consent" {...register('newsletter_consent', { required: false })}
                                mr="0"
                                sx={{
                                    'input:checked ~ &': {
                                        color: theme.colors.aquaDark,
                                    },
                                    color: theme.colors.aquaDark,
                                }
                                }
                            />
                        </Flex>
                    </Label>
                </Box>
            </Flex>
        </ContactForm>
    )
}

export default GenericForm
